import type { UserAddonListQuery_Query } from '~/gql/generated/graphql'

type NonNullableUser = NonNullable<UserAddonListQuery_Query['user']>

// Define a skeleton of data so the table can be shown
// with the loading state if there isn't any data yet
export const defaultData: UserAddonListQuery_Query & {
  user: NonNullableUser
} = {
  __typename: 'Query',
  user: {
    __typename: 'User',
    id: '',
    table: {
      __typename: 'UserAddonConnection',
      nodes: [],
      pagination: {
        __typename: 'Pagination',
        total: 0,
        current: 0,
        pageSize: 0,
      },
    },
  },
}
